export default __webpack_public_path__ + "static/media/4 - Растения в вестибюле.662fafbd.jpg";